import React from "react";
import { Reveal } from "../hooks/useReveal";

const ITEMS = [
  {
    n: "01",
    title: "Naturally Scarce",
    body: "Platinum is a naturally scarce precious metal with concentrated global production.",
  },
  {
    n: "02",
    title: "Industrial Demand",
    body: "Platinum plays an important role across automotive, chemical and other industrial applications.",
  },
  {
    n: "03",
    title: "Precious Metal",
    body: "Platinum is globally recognized as a high-value precious metal.",
  },
  {
    n: "04",
    title: "Real World Asset",
    body: "XPTY connects a physical commodity with modern blockchain-based financial infrastructure.",
  },
  {
    n: "05",
    title: "Fractional Representation",
    body: "Each XPTY represents only 10 milligrams of Platinum, creating precise digital units.",
  },
  {
    n: "06",
    title: "Digital Infrastructure",
    body: "XPTY is designed to allow Platinum-linked value to interact with compatible on-chain infrastructure.",
  },
];

export default function WhyPlatinum() {
  return (
    <section className="w-full py-[80px] lg:py-[140px]">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-[64px]">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-10 items-end">
          <div className="lg:col-span-7">
            <Reveal>
              <span className="micro-label">Why Platinum</span>
              <h2 className="mt-5 text-[32px] sm:text-[42px] lg:text-[52px] font-medium tracking-[-0.02em] leading-[1.05] text-[#F1F2EF]">
                A scarce precious metal with global relevance.
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-5">
            <Reveal delay={0.08}>
              <p className="text-[16px] leading-[1.6] text-[#A0A5A2] max-w-[420px]">
                Platinum occupies a distinctive position between precious metals,
                industrial materials and strategic global commodities.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 border-t border-l hairline">
          {ITEMS.map((it, i) => (
            <Reveal key={it.n} delay={(i % 3) * 0.05}>
              <div className="group border-b border-r hairline px-6 lg:px-8 py-10 h-full transition-colors duration-300 hover:bg-[#0D0E0E]">
                <div className="text-[11px] tracking-[0.18em] text-[#6D726F] tabular-nums">
                  {it.n} / 06
                </div>
                <h3 className="mt-8 text-[20px] font-medium text-[#F1F2EF]">
                  {it.title}
                </h3>
                <p className="mt-3 text-[14px] leading-[1.6] text-[#A0A5A2]">
                  {it.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
